module.exports = __webpack_public_path__ + "static/media/GlassVibes.a58b652c.mp3";